export default {
  blue: 'blue',
  black: 'black',
  primaryGreen: '#1ca75d',
  secondaryGreen: 'rgb(61,179,106)',
  darkMint: 'rgb(72,189,126)',
  white: 'white',
  shadowColor: 'rgb(35,35,35)',
  transparent: 'transparent',
  purplishBlue: 'rgb(78, 15, 255)',
  purpleishBlue: 'rgb(89,80,249)',
  paleGrey: 'rgb(246,245,248)',
  greyishBrown: 'rgb(71,71,71)',
  coralPink: 'rgb(255,94,107)',
  jade: 'rgb(29,167,93)',
  whiteTransparent10: 'rgba(255, 255, 255, 0.1)',
};
